// extracted by mini-css-extract-plugin
export default {"container":"NavPanel_container__4GSF0","buttons":"NavPanel_buttons__nbOG0"};